import { api, FilterOptionsResponse } from "../index";
import { Order } from "./dto/orders.dto";

const ORDERS_ENDPOINT = "/order";
const ADMIN_ENDPOINT = "/admin";

export const OrdersAPI = api.injectEndpoints({
	endpoints: build => ({
		getOrders: build.query<FilterOptionsResponse<Order[]>, { page: number; perPage: number }>({
			query: ({ page, perPage }) => ({
				url: `${ORDERS_ENDPOINT}/list`,
				params: { page, perPage },
				method: "GET"
			}),
			providesTags: []
		}),
		getAdminOrders: build.query<FilterOptionsResponse<Order[]>, { page: number; perPage: number }>({
			query: ({ page, perPage }) => ({
				url: `${ADMIN_ENDPOINT}/orders`,
				params: { page, perPage },
				method: "GET"
			}),
			providesTags: []
		})
	})
});

export const { useLazyGetOrdersQuery, useLazyGetAdminOrdersQuery } = OrdersAPI;
